// extracted by mini-css-extract-plugin
module.exports = {"action":"TableBox_action__3GOk2","item":"TableBox_item__Ua4Az","tdcolor":"TableBox_tdcolor__2kfLn"};